import { Alert } from "@caspeco/casper-ui-library";
import { useAvailableTimes } from "api/api-hooks/use-available-times";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import AlertSkeleton from "components/skeletons/alert-skeleton";
import { useBookingStateContext } from "hooks/use-booking-state";
import { useSelectedRule, useSelectedRules } from "hooks/use-selected-rule";
import { useTranslation } from "react-i18next";
import { CurrencyDisplay } from "translations/currency";
import { getPaymentCalculationTotal, getPaymentUnitTranslation } from "utils/payment-utils";
const PrepaymentAlert = () => {
    const { t } = useTranslation();
    const rules = useSelectedRules();
    const selectedRule = useSelectedRule();

    const state = useBookingStateContext();
    const { data: webBooking } = useWebBooking();
    const reservation = useWebBooking();

    const availableTimes = useAvailableTimes(state.date);

    if (availableTimes.isPending && !webBooking?.webBookingRules) return <AlertSkeleton />;

    const guests = state.guests ? state.guests : (webBooking?.guests ?? 0);

    const paymentTotalFromRule = getPaymentCalculationTotal(
        selectedRule ?? null,
        guests,
        reservation.data?.articles?.filter(
            (art) => art.isTable && art.ruleId === selectedRule?.id
        ) ?? []
    );

    /**
     * If more than one rule is selected we show a generic alert
     * or if the rule’s payment total is 0, indicating that the payment is derived from the menu cost
     */
    if (rules.length > 1 || paymentTotalFromRule === 0) {
        return (
            <Alert type="info" iconVerticalAlign="flex-start">
                {t("prePaymentMultiInfoAlert", {
                    totalValue: reservation.data?.chargeShouldPayAmount,
                })}
            </Alert>
        );
    }

    return (
        <Alert type="info" iconVerticalAlign="flex-start">
            {t("prePaymentInfoAlert", {
                totalValue: paymentTotalFromRule,
                unitAmount: selectedRule?.paymentAmount,
                display: CurrencyDisplay.Symbol,
                unit: selectedRule ? getPaymentUnitTranslation(selectedRule) : "",
            })}
        </Alert>
    );
};

export default PrepaymentAlert;
